/*
================================================================================

  "Clients" section

================================================================================
*/

import Swiper from 'swiper';


const ClientsSection = (() => {
  let sliderInstance;
  

  const initSlider = function() {
    const BREAKPOINT_568_PX = matchMedia('(max-width: 35.49em)');

    if (BREAKPOINT_568_PX.matches) {
      if (sliderInstance === undefined || sliderInstance.hasOwnProperty('destroyed') ) {
        const clientsLogosElem = document.querySelector('.clients-logos');
        const sliderElem = clientsLogosElem.querySelector('.clients-logos__slider');
        const paginationElem = clientsLogosElem.querySelector('.slider-pagination');

        sliderInstance = new Swiper(sliderElem, {
          autoplay: {
            delay: 3000
          },
          centeredSlides: true,
          loop: true,
          slidesPerView: 2.8,
          spaceBetween: 50,
          speed: 500,
          pagination: {
            el: paginationElem,
            type: 'bullets',
            bulletClass: 'slider-pagination__bullet',
            bulletActiveClass: 'js-active',
            modifierClass: 'slider-pagination--',
            currentClass: 'js-current',
            totalClass: 'js-total',
            hiddenClass: 'js-hidden',
            clickableClass: 'js-clickable'
          }
        });
      }
    } else {
      if (sliderInstance !== undefined && !sliderInstance.hasOwnProperty('destroyed')) {
        sliderInstance.destroy(true, true);
      }
    }
  };

  const initEventListeners = function() {
    if (document.querySelector('.clients')) {
      window.addEventListener('load', initSlider);
      window.addEventListener('resize', initSlider);
    }
  };

  const init = function() {
    initEventListeners();
  };

  return {
    init: init
  };

})();

export default ClientsSection;
